
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import store from '@/store'

/**
 * @returns {Promise<T>}
 */
export async function getOptimizeBroadcast () {
  const sitimmoUser = store.getters.getSitimmoUser
  const url = `/v2/optimize-broadcast?professionId=${sitimmoUser.metier}`
  return HTTP_HYPER_ESPACE_BACKEND
    .get(url)
    .then(async response => {
      return response.data
    })
    .catch(error => {
      console.log(error)
      return error
    })
}

/**
 * @param params
 * @returns {Promise<T>}
 */
export async function updateSettingsCollection (params) {
  const url = '/v2/update-settings-collection'
  return HTTP_HYPER_ESPACE_BACKEND
    .post(url, params)
    .then(async response => {
      return response.data
    })
    .catch(error => {
      return error
    })
}
